import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WhseJob0601Actions, { WhseJob0601Types } from '../Stores/WhseJob0601/Actions';

const getAppStore = state => state.app;

export function* whseJob0601FetchWhseJob0601({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(WhseJob0601Actions.whseJob0601FetchWhseJob0601Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexProcess/WHSE_JOB_06_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        WhseJob0601Actions.whseJob0601FetchWhseJob0601Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob0601Actions.whseJob0601FetchWhseJob0601Loading(false));
  }
}

export function* whseJob0601CreateWhseJob0601({ hdrIds, toStorageBinId }) {
  try {
    yield put(WhseJob0601Actions.whseJob0601CreateWhseJob0601Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds,
      toStorageBinId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `whseJob/createProcess/WHSE_JOB_06_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(WhseJob0601Actions.whseJob0601CreateWhseJob0601Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob0601Actions.whseJob0601CreateWhseJob0601Loading(false));
  }
}

export function* whseJob0601GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/loadListDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(WhseJob0601Types.WHSE_JOB0601_GO_TO_DOCUMENT, whseJob0601GoToDocument),
  takeLatest(WhseJob0601Types.WHSE_JOB0601_FETCH_WHSE_JOB0601, whseJob0601FetchWhseJob0601),
  takeLatest(WhseJob0601Types.WHSE_JOB0601_CREATE_WHSE_JOB0601, whseJob0601CreateWhseJob0601)
];
